<template>
  <div id="share-modal">
    <!-- Edit post modal -->
    <div class="post-modal">
      <div class="post-modal-content">
        <div class="post-modal-header">
          <a @click="closeShareModal" class="close"><i class="far fa-times"></i></a>
          <p class="lead">Share View</p>
        </div><!-- /. post-modal-header -->
        <div class="post-modal-body">

          <div class="card">
            <div class="card-header">
              Share link
            </div><!-- /.card-header -->
            <div class="card-body">
                <code>{{ shareLink }}</code>
            </div><!-- /.card-body -->
          </div><!-- /.card -->
          <br>
          <div class="card">
            <div class="card-header">
              Embed code
            </div><!-- /.card-header -->
            <div class="card-body">
              <code>&#60;iframe src=&#34;{{ shareLink }}&#34; width=&#34;100%&#34; height=&#34;500px&#34; frameborder=&#34;0&#34; allowfullscreen&#62;&#60;/iframe&#62;</code>
            </div><!-- /.card-body -->
          </div><!-- /.card -->

        </div><!-- /.post-modal-body -->
        <div class="post-modal-footer">
          <div class="float-right">
            <button @click="closeShareModal" class="btn btn-secondary">Close</button>
          </div><!-- /.float-right -->
        </div><!-- /.post-modal-footer -->
      </div><!-- /.post-modal-content -->
    </div><!-- /.post-modal -->
  </div><!-- /#lists-select-modal -->
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  const fb = require('../firebaseConfig.js')

  export default {
    props: ['fullPost', 'viewMode'],
    data() {
      return {
        shareLink: ''
      }
    },
    computed: {
      ...mapState(['currentUser'])
    },
    created: function() {
      // List sharelinks
      if (this.viewMode == 'postsMap' && this.$route.name == 'List') {
        this.shareLink = 'https://cdp.orbitist.com/viz/map/list/' + this.$route.params.id
      }
      if (this.viewMode == 'postsTimeline' && this.$route.name == 'List') {
        this.shareLink = 'https://cdp.orbitist.com/viz/timeline/list/' + this.$route.params.id
      }
      if (this.viewMode == 'dashboardHome' && this.$route.name == 'List') {
        this.shareLink = 'https://cdp.orbitist.com/viz/dashboard/list/' + this.$route.params.id
      }
      if (this.viewMode == 'postsMasonry' && this.$route.name == 'List') {
        this.shareLink = 'https://cdp.orbitist.com/viz/grid/list/' + this.$route.params.id
      }


      // User sharelinks
      if (this.viewMode == 'postsMap' && this.$route.path == '/dashboard/map') {
        this.shareLink = 'https://cdp.orbitist.com/viz/map/user/' + this.currentUser.uid
      }
      if (this.viewMode == 'postsTimeline' && this.$route.path == '/dashboard/timeline') {
        this.shareLink = 'https://cdp.orbitist.com/viz/timeline/user/' + this.currentUser.uid
      }
      if (this.viewMode == 'dashboardHome' && this.$route.path == '/dashboard') {
        this.shareLink = 'https://cdp.orbitist.com/viz/dashboard/user/' + this.currentUser.uid
      }
      if (this.viewMode == 'postsMasonry' && this.$route.path == '/dashboard/grid') {
        this.shareLink = 'https://cdp.orbitist.com/viz/grid/user/' + this.currentUser.uid
      }

    },
    methods: {
      closeShareModal() {
        this.$emit('closeShareModal')
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          let regex = /(<([^>]+)>)/ig;
          let cleanVal = val.replace(regex, " ");
          return cleanVal
         }
        let regex = /(<([^>]+)>)/ig;
        let cleanVal = val.replace(regex, " ");
        return `${cleanVal.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ShareModal.vue